import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import TaskManagementActions from '../actions/taskmanagement.actions';

export function* getAssignerTasksRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getAssignerTasks(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(TaskManagementActions.getAssignerTasksSuccess(response.data));
  } else {
    yield put(TaskManagementActions.getAssignerTasksFailure());
  }
}

export function* createNewTaskRequest(api, action) {
  const { payload } = action;
  const response = yield api.createNewTask(payload);
  if (response && response.ok) {
    InsighttNotification('success', 'New Task was created successfully', response);
    yield put(TaskManagementActions.createNewTaskSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to create new task', response);
    yield put(TaskManagementActions.createNewTaskFailure());
  }
}

export function* closeTaskRequest(api, action) {
  const { taskId, payload } = action;
  const response = yield api.closeTask(taskId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'The task was closed successfully', response);
    yield put(TaskManagementActions.closeTaskSuccess(taskId));
  } else {
    InsighttNotification('error', 'Unable to close the task', response);
    yield put(TaskManagementActions.closeTaskFailure(taskId));
  }
}

export function* readTaskRequest(api, action) {
  const { taskId } = action;
  const response = yield api.readTask(taskId);
  if (response && response.ok) {
    yield put(TaskManagementActions.readTaskSuccess(taskId));
  }
}

export function* approveCompletedRequest(api, action) {
  const { taskId } = action;
  const response = yield api.approveCompleted(taskId);
  if (response && response.ok) {
    InsighttNotification('success', 'Task was approved as completed', response);
    yield put(TaskManagementActions.approveCompletedSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to approve the task completed', response);
    yield put(TaskManagementActions.approveCompletedFailure(taskId));
  }
}

export function* rejectCompletedRequest(api, action) {
  const { taskId, payload } = action;
  const response = yield api.rejectCompleted(taskId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Task completion was rejected', response);
    yield put(TaskManagementActions.rejectCompletedSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to reject the task completed', response);
    yield put(TaskManagementActions.rejectCompletedFailure(taskId));
  }
}

export function* approveNewDeadlineRequest(api, action) {
  const { taskId } = action;
  const response = yield api.approveNewDeadline(taskId);
  if (response && response.ok) {
    InsighttNotification('success', 'New Deadline was approved successfully', response);
    yield put(TaskManagementActions.approveNewDeadlineSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to approve new deadline', response);
    yield put(TaskManagementActions.approveNewDeadlineFailure(taskId));
  }
}

export function* declineNewDeadlineRequest(api, action) {
  const { taskId, payload } = action;
  const response = yield api.declineNewDeadline(taskId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'New Deadline was declined successfully', response);
    yield put(TaskManagementActions.declineNewDeadlineSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to decline new deadline', response);
    yield put(TaskManagementActions.declineNewDeadlineFailure(taskId));
  }
}

export function* getReceiverTasksRequest(api, action) {
  const { branchId, startDate, endDate, timezoneOffset } = action;
  const response = yield api.getReceiverTasks(branchId, startDate, endDate, timezoneOffset);
  if (response && response.ok) {
    yield put(TaskManagementActions.getReceiverTasksSuccess(response.data));
  } else {
    yield put(TaskManagementActions.getReceiverTasksFailure());
  }
}

export function* proposeNewDeadlineRequest(api, action) {
  const { taskId, payload } = action;
  const response = yield api.proposeNewDeadline(taskId, payload);
  if (response && response.ok) {
    InsighttNotification('success', 'New Deadline was submitted successfully', response);
    yield put(TaskManagementActions.proposeNewDeadlineSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to submit new deadline', response);
    yield put(TaskManagementActions.proposeNewDeadlineFailure(taskId));
  }
}

export function* cancelNewDeadlineRequest(api, action) {
  const { taskId } = action;
  const response = yield api.cancelNewDeadline(taskId);
  if (response && response.ok) {
    InsighttNotification('success', 'New Deadline was cancelled successfully', response);
    yield put(TaskManagementActions.cancelNewDeadlineSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to cancel new deadline', response);
    yield put(TaskManagementActions.cancelNewDeadlineFailure(taskId));
  }
}

export function* markAsCompletedRequest(api, action) {
  const { taskId } = action;
  const response = yield api.markAsCompleted(taskId);
  if (response && response.ok) {
    InsighttNotification('success', 'Task was marked completed', response);
    yield put(TaskManagementActions.markAsCompletedSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to mark task completed', response);
    yield put(TaskManagementActions.markAsCompletedFailure(taskId));
  }
}

export function* acknowledgeUncompletedRequest(api, action) {
  const { category, taskId } = action;
  const response = yield api.acknowledgeUncompleted(taskId);
  if (response && response.ok) {
    InsighttNotification('success', 'Task was acknowledged as uncompleted', response);
    yield put(TaskManagementActions.acknowledgeUncompletedSuccess(category, taskId));
  } else {
    InsighttNotification('error', 'Unable to acknowledge task uncompleted', response);
    yield put(TaskManagementActions.acknowledgeUncompletedFailure(taskId));
  }
}
